import React from 'react';
import { noop } from 'lodash';
import { Wrap } from '@fiverr-private/layout_components';
import { useImpressionableRef } from '../../hooks/useImpressionableRef';
import { useTagsContext } from './TagsContext/TagsContext';
import { TagItemWrapper } from './TagItems/TagItemWrapper';

export const TagsContainer = () => {
    const {
        tags,
        onViewTags = noop,
        shownTags,
        tagsLayout,
        TagItem,
        ShowMoreTagsItem,
        onShowMoreTags,
        showAllTags,
    } = useTagsContext();
    const ref = useImpressionableRef({
        onImpression: () => onViewTags({ tags, tagsToShow: shownTags.length }),
    });

    const onClickShowMore = () => {
        onShowMoreTags({ tags, tagsToShow: shownTags.length });
        showAllTags();
    };

    return (
        <Wrap gap={tagsLayout.gap} ref={ref}>
            {shownTags.map((tag) => (
                <TagItemWrapper key={tag.label}>
                    <TagItem label={tag.label} icon={tag.icon} />
                </TagItemWrapper>
            ))}
            <TagItemWrapper>
                <ShowMoreTagsItem onClickShowMore={onClickShowMore} />
            </TagItemWrapper>
        </Wrap>
    );
};
